import React from 'react';
import { LandingPage } from './pages/LandingPage';
export function App() {
  return <>
      <style dangerouslySetInnerHTML={{
      __html: `
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&family=Nunito:wght@300;400;600;700;800&display=swap');
        
        :root {
          --font-heading: 'Syne', sans-serif;
          --font-body: 'Nunito', sans-serif;
        }
        
        .font-heading, h1, h2, h3, h4, h5, h6 {
          font-family: var(--font-heading);
        }
        
        .font-body, body, p, span, div {
          font-family: var(--font-body);
        }
        
        html {
          scroll-behavior: smooth;
        }
      `
    }} data-id="element-0" />
      <LandingPage data-id="element-1" />
    </>;
}